import React, { Component } from 'react';
import DismissMessageButton from './components/DismissMessageButton';
import { connect } from 'react-redux';
import { cleanMessages } from '../../actions/messages.js';

/**
 * Component for showing the message list.
 *
 * @extends React.Component
 */
class MessageList extends Component {
  /** @inheritdoc */
  render() {
    // Messages lives a maximum of 5 seconds, but someone has to clean up. Start
    // an interval each second that cleans up.
    var ctx = this;
    setTimeout(() => {
      ctx.props.dispatch(cleanMessages());
    }, 1000);

    return (
      <div className="messages">
        {this.props.messages.map((message, i) => {
          var classes = 'alert alert-' + message.severity;
          return (
            <div className={classes} role="alert" key={i}>
              <DismissMessageButton messageId={i} />{message.message}
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect()(MessageList);



// WEBPACK FOOTER //
// ./src/components/MessageList/index.js